import React from "react";

const DOCTOR_IMG =
  "https://cdn-icons-png.flaticon.com/512/3874/3874091.png"; // Flat vector doctor illustration

export default function HeroCard24() {
  return (
    <>
      <section className="hc-hero">
        {/* LEFT SLIDER DOTS */}
        <div className="hc-dot-cm-hc24s">
          <span className="dot-cm-hc24 active"></span>
          <span className="dot-cm-hc24"></span>
          <span className="dot-cm-hc24"></span>
        </div>

        {/* TEXT CONTENT */}
        <div className="hc-left">
          <h4 className="hc-script">Our People and Society</h4>

          <h1 className="hc-title">
            We Always Put the <br />
            <span>Patients First</span>
          </h1>

          <p className="hc-desc">
            Te obtinuit ut adepto satis somno. Aliisque institioribus iter
            deliciae vivet vita. Nam exempli gratia, quotiens.
          </p>

          <button className="hc-btn">
            <span className="hc-btn-icon">⚕️</span> Read More
          </button>
        </div>

        {/* ILLUSTRATION */}
        <div className="hc-right">
          <img src={DOCTOR_IMG} alt="doctor illustration" className="hc-doc" />
        </div>

        {/* FLOATING MEDICAL BUTTON */}
        <button className="hc-float-btn">💙</button>
      </section>

      <style>{`
/* -------- HERO WRAPPER -------- */
.hc-hero {
  display: flex;
  justify-content: space-between;
  padding: 80px 6%;
  min-height: 75vh;
  background: linear-gradient(90deg, #d9ecff 0%, #e4f2ff 60%, #e9f5ff 100%);
  position: relative;
  overflow: hidden;
}

/* -------- LEFT SIDE -------- */
.hc-left {
  width: 50%;
  padding-top: 40px;
}

/* Script Heading */
.hc-script {
  font-family: "Brush Script MT", cursive;
  font-size: 1.8rem;
  color: #2899c8;
  margin-bottom: 16px;
}

/* Main Title */
.hc-title {
  font-size: 3.3rem;
  font-weight: 800;
  color: #08325b;
  line-height: 1.15;
}
.hc-title span {
  color: #0eb7df;
}

/* Description */
.hc-desc {
  margin-top: 20px;
  font-size: 1.1rem;
  max-width: 550px;
  color: #364b63;
  line-height: 1.6;
}

/* CTA Button */
.hc-btn {
  margin-top: 28px;
  background: #08b6e4;
  border: none;
  padding: 14px 28px;
  border-radius: 40px;
  color: white;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 6px 20px rgba(8, 182, 228, 0.3);
}

.hc-btn-icon {
  background: white;
  color: #08b6e4;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 1rem;
}

/* -------- RIGHT SIDE -------- */
.hc-right {
  width: 45%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.hc-doc {
  width: 420px;
  max-width: 100%;
  object-fit: contain;
  animation: float 4s ease-in-out infinite;
}

/* Floating illustration effect */
@keyframes float {
  0% { transform: translateY(0); }
  50% { transform: translateY(-14px); }
  100% { transform: translateY(0); }
}

/* -------- LEFT SLIDER DOTS -------- */
.hc-dot-cm-hc24s {
  position: absolute;
  left: 40px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.hc-dot-cm-hc24s .dot-cm-hc24 {
  width: 10px;
  height: 10px;
  background: #0eb7df;
  border-radius: 50%;
  opacity: 0.3;
}
.hc-dot-cm-hc24s .dot-cm-hc24.active {
  opacity: 1;
  transform: scale(1.6);
}

/* -------- FLOATING BUTTON -------- */
.hc-float-btn {
  position: absolute;
  bottom: 30px;
  right: 30px;
  background: #0b6bbd;
  color: #fff;
  width: 50px;
  height: 50px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  font-size: 20px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.2);
}

/* -------- RESPONSIVE -------- */
@media (max-width: 1000px) {
  .hc-hero {
    flex-direction: column-reverse;
    text-align: center;
    padding-top: 40px;
  }
  .hc-left, .hc-right {
    width: 100%;
  }
  .hc-dot-cm-hc24s {
    left: 16px;
  }
}
      `}</style>
    </>
  );
}
